import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    inputRoot: {
      '& input': {
        '&[type=number]': {
          '-moz-appearance': 'textfield',
        },
        '&::-webkit-outer-spin-button': {
          '-webkit-appearance': 'none',
          margin: 0,
        },
        '&::-webkit-inner-spin-button': {
          '-webkit-appearance': 'none',
          margin: 0,
        },
      },
    },
    input: {
      width: '100%',

      '& > *': {
        height: 45,
        borderRadius: 8,
        borderColor: '#E1E8ED !important',
      },
    },
    defaultStyle: {},
  }),
);

export default useStyles;
